<template>
  <v-card flat elevation="0">
    <DrawerToolbar title="Add a reward" @close="close" />
    <div class="mt-5 preset-container pa-4">
      <RewardInputState
        :showTitle="false"
        paymentLanguage="Reward"
        :showBudgetSelector="
          !!(showBudgetSelector && (loadingBudgets || (budgets && budgets.length)))
        "
        :budgets="budgets"
        :loadingBudgets="loadingBudgets"
        :budgetId="budgetId"
        :customEmoji="customEmoji"
        :customAmount="customAmount"
        :cashAward="cashAward"
        :showAddAmountButton="true"
        @update-budgetId="computedBudgetId = $event"
        @update-custom-amount="customRewardAmount = $event"
        @update-custom-emoji="customRewardEmoji = $event"
        @select-custom-reward="selectCustomReward"
        @blur="onBlur"
      />
      <div v-if="loading" class="d-flex justify-center">
        <v-progress-circular
          indeterminate
          :size="35"
          :width="3"
          color="brandCyan"
        ></v-progress-circular>
      </div>
      <div v-else>
        <div class="text-center pb-6">
          <Typography variant="subtitle-1" class="">Or</Typography>
        </div>
        <div class="text-left">
          <Typography variant="subtitle-1" class="pb-2">Select a reward preset</Typography>
          <Typography variant="body-1"
            >Presets are just a suggestion — the recipient can spend points on anything they
            like.</Typography
          >
        </div>
      </div>
      <v-hover v-for="preset in presets" :key="preset.paymentPresetId" v-slot="{ hover }">
        <v-card
          class="preset-selector-box full-width my-6"
          width="75%"
          elevation="0"
          @click="selectPreset(preset)"
        >
          <span class="preset-selector-emoji" :class="{ wiggle: hover }">{{ preset.emoji }}</span>
          <div class="d-flex flex-column text-left">
            <Typography variant="subtitle-1">{{ preset.displayName }}</Typography>
            <Typography variant="body-1">{{ formatRewardAmount(preset.amount) }}</Typography>
          </div></v-card
        >
      </v-hover>
    </div>
  </v-card>
</template>

<script>
import rewardAmountMixin from "@/mixins/rewardAmountMixin.js";
import DrawerToolbar from "@/components/generic/DrawerToolbar.vue";
import RewardInputState from "@/components/recognition/RewardSelector/RewardInputState.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "RewardDrawer",
  mixins: [rewardAmountMixin],
  components: {
    DrawerToolbar,
    Typography,
    RewardInputState,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    showBudgetSelector: {
      type: Boolean,
      default: false,
    },
    loadingBudgets: {
      type: Boolean,
      default: false,
    },
    budgets: {
      type: Array,
      default: () => [],
    },
    budgetId: {
      type: Number,
      default: null,
    },
    cashAward: {
      type: Boolean,
      default: true,
    },
    presets: {
      type: Array,
      default: () => [],
    },
    customEmoji: {
      type: String,
      default: null,
    },
    customAmount: {
      type: String,
      default: null,
    },
  },
  emits: ["blur"],
  data() {
    return {};
  },
  created() {},
  unmounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    onBlur() {
      this.$emit("blur");
    },
    selectCustomEmoji(emoji) {
      this.customRewardEmoji = emoji;
    },
    selectPreset(e) {
      this.$emit("select-reward", e);
    },
    selectCustomReward() {
      this.$emit("select-custom-reward");
    },
  },
  computed: {
    customRewardEmoji: {
      get: function () {
        return this.customEmoji;
      },
      set: function (newVal) {
        this.$emit("update-custom-emoji", newVal);
      },
    },
    customRewardAmount: {
      get: function () {
        return this.customAmount;
      },
      set: function (newVal) {
        this.$emit("update-custom-amount", newVal);
      },
    },
    computedBudgetId: {
      get: function () {
        return this.budgetId;
      },
      set: function (newVal) {
        this.$emit("update-budgetId", newVal);
      },
    },
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@-webkit-keyframes wiggle {
  0% {
    -webkit-transform: rotate(10deg);
  }
  25% {
    -webkit-transform: rotate(-10deg);
  }
  50% {
    -webkit-transform: rotate(5deg);
  }
  75% {
    -webkit-transform: rotate(-5deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}

@-ms-keyframes wiggle {
  0% {
    -ms-transform: rotate(10deg);
  }
  25% {
    -ms-transform: rotate(-10deg);
  }
  50% {
    -ms-transform: rotate(5deg);
  }
  75% {
    -ms-transform: rotate(-5deg);
  }
  100% {
    -ms-transform: rotate(0deg);
  }
}
@keyframes wiggle {
  0% {
    transform: rotate(10deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(5deg);
  }
  75% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
  /* 0% {
    transform: rotate(10deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(20deg);
  }
  75% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  } */
}
.wiggle {
  display: inline-block;
  animation-name: wiggle;
  -webkit-animation-name: wiggle;
  -ms-animation-name: wiggle;
  animation-duration: 1s;
  -ms-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-iteration-count: 1;
  -webkit-animation-iteration-count: 1;
  -ms-animation-iteration-count: 1;
}
</style>
